var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localValue.type === 'dropdown')?_c('div',{style:('margin: ' + _vm.styles.margin.join('px ') + 'px;' +
    'color:' + _vm.styles.color + ';'),attrs:{"id":'localValue' + _vm.index}},[(!_vm.hideLabels)?_c('div',{staticClass:"text-sm font-semibold mb-2",style:('text-align: ' + _vm.styles.text.textAlign + ';' +
      'color: ' + _vm.styles.labelColor + ';')},[_vm._v(" "+_vm._s(_vm.localValue.label)+" "),(
      _vm.localValue.mandatory === true ||
      _vm.localValue.mandatory === 1 ||
      _vm.localValue.mandatory === 'true'
      )?_c('span',{staticStyle:{"color":"red","font-weight":"bold"}},[_vm._v("*")]):_vm._e()]):_vm._e(),_c('select',{staticClass:"rounded w-full focus:outline-none text-sm rounded bg-white",style:('background:' + _vm.styles.backgroundColor + ';' +
      'box-shadow:' + (_vm.styles.boxShadow ?? '') + ';' +
      'padding: ' + _vm.styles.padding.join('px ') + 'px;' +

      '--form-style-placeholder-color:' + _vm.styles.placeholderColor + ';' +
      'font-family:' + (_vm.styles.text.fontFamily || '') + ';' +
      'text-shadow:' + (_vm.styles.text.textShadow || '') + ';' +
      'font-size:' + _vm.styles.text.fontSize + 'px;' +
      'text-align:' + _vm.styles.text.textAlign + ';' +
      'font-style:' + (_vm.styles.text.fontStyle || '') + ';' +
      'font-weight:' + (_vm.styles.text.fontWeight || '') + ';' +
      'letter-spacing:' + (_vm.styles.text.letterSpacing || '') + ';' +
      'line-height:' + (_vm.styles.text.lineHeight || '') + ';' +
      '-webkit-text-stroke-width:' + (_vm.styles.text.textStrokeWidth || '') + ';' +
      '-webkit-text-stroke-color:' + (_vm.styles.text.textStrokeColor || '') + ';' +
      'text-decoration-line:' + (_vm.styles.text.textDecorationLine || '') + ';' +
      'color:' + _vm.styles.text.color + ';' +

      'border-width:' + _vm.styles.border?.width.join('px ') + 'px;' +
      'border-radius:' + _vm.styles.border?.radius.join('px ') + 'px;' +
      'border-color:' + _vm.styles.border?.color.join(' ') + ';' +
      'border-style:' + _vm.styles.border?.style.join(' ') + ';' +
      _vm.styles.customStyles ?? '')},[(_vm.hideLabels)?_c('option',{attrs:{"disabled":"","selected":""}},[_vm._v(_vm._s(_vm.localValue.label))]):_vm._e(),_vm._l((_vm.localValue.options),function(option,index){return _c('option',{key:index},[_vm._v(" "+_vm._s(option)+" ")])})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }